<!--  -->
<template>
  <div class="validation">
    <h3>请验证以下网址：</h3>
    <div class="local">
      <h5>{{ submain }}</h5>
      <h6>{{ domain }}</h6>
    </div>
    <div class="footer">
      <button @click="back">后退</button>
      <button @click="canl">取消</button>
      <button class="next" @click="nexted">下一步</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      submain: "博客",
      domain: "博客.cloudcc.com",
    };
  },
  methods: {
    back() {
      this.$emit("nexted", 1);
    },
    nexted() {
      this.$emit("nexted", 3);
    },
    canl() {
      this.$router.push({ path: "/setuppage/marketDnsSetting" });
    },
  },
};
</script>

<style lang='scss' scoped >
::v-deep :focus{
  outline: 0;
}
.validation {
  width: 100%;
  margin-top: 110px;
  h3 {
    width: 100%;
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #080707;
    letter-spacing: 0;
    text-align: center;
    font-weight: bold;
  }
  .local {
    width: 60%;
    margin-left: 20%;
    background: #ffffff;
    border: 1px solid #dedcda;
    border-radius: 2px;
    min-height: 90px;
    display: flex;
    align-items: center;
    margin-top: 47px;
    h5 {
      width: 180px;
      margin-left: 15px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #000000;
      letter-spacing: 0;
    }
    h6 {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #000000;
      letter-spacing: 0;
    }
  }
  .footer {
    width: 100%;
    height: 73px;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-top: 1px solid #dddbda;
    button {
      outline: none;
      margin-right: 10px;
      border: 1px solid #dedcda;
      border-radius: 3px;
      padding: 10px 22px;
      cursor: pointer;
      background: #ffffff;
    }
    .next {
      background: #006dcc;
      border-radius: 3px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
    }
  }
}
</style>
